// extracted by mini-css-extract-plugin
module.exports = {"RecentArticles":"_1JAuTYyR","articles":"mApMPvSN","allArticles":"_255rH0q6","link":"_2RW4JhFm"};